import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class IssueService {

    private firstQueryString: boolean = false;

    constructor(private http: HttpClient,
        @Inject('API_BASE_URL') private baseUrl: string) { }
    // #region PAYG_region
    paygSummary(clientId: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygsummary/' + clientId;

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get payg summary"
                    });
                });
        });
        return promise;
    }

    billingSummary(clientId: number): Promise<any> {
        let url = this.baseUrl + 'issues/billingsummary/' + clientId;

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get billing summary"
                    });
                });
        });
        return promise;
    }

    getIssueHistory(clientId: number): Promise<any> {
        let url = this.baseUrl + 'issues/history/' + clientId;

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get credit statuses"
                    });
                });
        });
        return promise;
    }


    creditStatuses(clientId: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygemergencycredit/' + clientId;

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get credit statuses"
                    });
                });
        });
        return promise;
    }

    issuePAYGEmergencyCreditSummary(clientId: number, siteId: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygemergencycreditsummary/' + clientId;

        if (siteId == 0) siteId = null;
        if (siteId) url = url + '?siteId=' + siteId.toString();

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get credit statuses"
                    });
                });
        });
        return promise;
    }

    issuePAYGEmergencyCreditDetail(clientId: number, page: number, pageSize?: number, timePeriod?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygemergencycreditdetail/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (timePeriod) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get credit emergency report"
                    });
                });
        });
        return promise;
    }

    issuePaygEmergencyCreditFrequency(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygemergencycreditfrequency/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get credit statuses"
                    });
                });
        });
        return promise;
    }

    issuePaygEmergencyCreditFrequencyDetail(clientId: number, page: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygemergencycreditfrequencydetail/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get credit frequency paged"
                    });
                });
        });
        return promise;
    }

    issuePaygHighBalance(clientId: number, siteId?: number): Promise<any> { // first service call
        let url = this.baseUrl + 'issues/payghighbalance/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get payg high balance"
                    });
                });
        });
        return promise;
    }

    issuePaygHighBalancePaged(clientId: number, page: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/payghighbalancedetail/' + clientId + "/page/" + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get payg high balance paged"
                    });
                });
        });
        return promise;
    }

    issuePaygGetLoans(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygconsumerloans/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get payg loans"
                    });
                });
        });
        return promise;
    }

    issuePaygGetLoansPaged(clientId: number, page: number, siteId?: number, pageSize?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygloans/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get payg loans paged"
                    });
                });
        });
        return promise;
    }

    issuePaygGetNoPayments(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygpayments/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get no payments"
                    });
                });
        });
        return promise;
    }

    issuePaygGetNoPaymentsPaged(clientId: number, page: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygnopayments/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get no payments paged"
                    });
                });
        });
        return promise;
    }

    issuePaygGetNoCommunicationPaged(clientId: number, page: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygnocommunications/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get payg no communication paged"
                    });
                });
        });
        return promise;
    }

    issuePaygGetNoCommunication(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/paygcommunications/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get payg no communication"
                    });
                });
        });
        return promise;
    }

    // #endregion

    // #region Billing_region

    getIssuesBilledInSlaSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/billingbilledinslasummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get billed in sla summary"
                    });
                });
        });
        return promise;
    }

    getIssuesBilledInSlaDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/billingbilledinsla/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get billed in sla detail"
                    });
                });
        });
        return promise;
    }

    getBillingLatestBillEstimatedSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/billinglatestbillestimatedsummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get latest bill estimated summary"
                    });
                });
        });
        return promise;
    }

    getBillingLatestBillEstimatedDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/billinglatestbillestimated/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get latest bill estimated detail"
                    });
                });
        });
        return promise;
    }

    getBillingAgedDebtSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/billingageddebtsummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get latest bill aged debt aummary"
                    });
                });
        });
        return promise;
    }

    getBillingAgedDebtDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/billingageddebt/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get latest bill aged debt summary"
                    });
                });
        });
        return promise;
    }

    getLowConsumptionSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/lowconsumptionsummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get low consumption summary"
                    });
                });
        });
        return promise;
    }

    getLowConsumptionDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/lowconsumption/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get low consumption detail"
                    });
                });
        });
        return promise;
    }

    getHighConsumptionDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/highconsumption/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get high consumption detail"
                    });
                });
        });
        return promise;
    }

    getHighConsumptionSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/highconsumptionsummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get high consumption summary"
                    });
                });
        });
        return promise;
    }

    getNoConsumptionDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/noconsumption/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get no consumption detail"
                    });
                });
        });
        return promise;
    }

    getRecentReadDataConsumptionDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/recentreaddata/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get recent read data detail"
                    });
                });
        });
        return promise;
    }

    getRecentReadDataConsumptionSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/recentreaddatasummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get recent read summary"
                    });
                });
        });
        return promise;
    }

    getReadDataAvailabilityConsumptionDetail(clientId: number, page?: number, pageSize?: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/readdataavailability/' + clientId + '/page/' + page;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (pageSize > 0) url = url.concat(this.createQueryStringParameter('pageSize', pageSize.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get read data availability detail"
                    });
                });
        });
        return promise;
    }

    getReadDataAvailabilityConsumptionSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/readdataavailabilitysummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get read data availability summary"
                    });
                });
        });
        return promise;
    }

    getNoConsumptionSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'issues/noconsumptionsummary/' + clientId;

        this.firstQueryString = true;

        if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get high consumption summary"
                    });
                });
        });
        return promise;
    }

    getConsumptionSummary(clientId: number): Promise<any> {
        let url = this.baseUrl + 'issues/consumptionsummary/' + clientId;

        this.firstQueryString = true;
        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get low consumption detail"
                    });
                });
        });
        return promise;
    }

    // #endregion

    private createQueryStringParameter(key: string, value: string) {
        var val = this.firstQueryString ? "?" : "&";
        this.firstQueryString = false;
        return val.concat(key).concat("=".concat(value));
    }

}
